import { useEffect, useState } from "react";
import { AnexosPDTO, ControlCambiosPDTO, DefinicionPDTO, DescripcionPDTO, Doc_ReferenciaPDTO, EncabezadoPDTO, RegistrosPDTO, ResponsabilidadPDTO } from "../../interfaces/ProcedimientosInterface";
import "./procedimientos.css";
import { API_PROCEDIMIENTOS } from "../../features/constants";
import logo from "../../assets/images/Logo_Taller_Avellaneda.png"

interface ProcedimientoProps{
    procedimiento: EncabezadoPDTO
}
export const Procedimiento = ({procedimiento}:ProcedimientoProps)=>{

    const [responsabilidades, setResponsabilidades] = useState<ResponsabilidadPDTO[]>([]);
    const [definiciones, setDefiniciones] = useState<DefinicionPDTO[]>([]);
    const [descripciones, setDescripciones] = useState<DescripcionPDTO[]>([]);
    const [documentosReferencia, setdocumentosReferencia] = useState<Doc_ReferenciaPDTO[]>([]);
    const [registros, setRegistros] = useState<RegistrosPDTO[]>([]);
    const [controlCambios, setControlCambios] = useState<ControlCambiosPDTO[]>([]);
    const [anexos, setAnexos] = useState<AnexosPDTO[]>([]);


    useEffect(()=>{
        let init = {
            method: "POST",
            body: JSON.stringify({
                Id: procedimiento.Id
            }),
            header:{
                "Content-Type":"aplication/json"
            }
        };
        fetch(API_PROCEDIMIENTOS + "/Responsabilidades",init)
            .then(response => response.json())
            .catch(error=>console.log(error))
            .then((data:ResponsabilidadPDTO[])=>{
                setResponsabilidades(data);
            })

        fetch(API_PROCEDIMIENTOS + "/Definiciones",init)
            .then(resp=>resp.json())
            .catch(err=>console.log(err))
            .then((data:DefinicionPDTO[])=>{
                setDefiniciones(data);
            });

        fetch(API_PROCEDIMIENTOS + "/Descripciones",init)
            .then(response=>response.json())
            .catch(err=>console.log(err))
            .then((data:DescripcionPDTO[])=>{
                setDescripciones(data);
            });

        fetch(API_PROCEDIMIENTOS + "/Documentos-Referencia",init)
            .then(response=>response.json())
            .catch(err=>console.log(err))
            .then((data:Doc_ReferenciaPDTO[])=>{
                setdocumentosReferencia(data);
            });
            
        fetch(API_PROCEDIMIENTOS + "/Registros",init)
            .then(response=>response.json())
            .catch(err=>console.log(err))
            .then((data:RegistrosPDTO[])=>{
                setRegistros(data);
            });
            
        fetch(API_PROCEDIMIENTOS + "/Control-Cambios",init)
            .then(response=>response.json())
            .catch(err=>console.log(err))
            .then((data:ControlCambiosPDTO[])=>{
                setControlCambios(data);
            });
            
        fetch(API_PROCEDIMIENTOS + "/Anexos",init)
            .then(response=>response.json())
            .catch(err=>console.log(err))
            .then((data:AnexosPDTO[])=>{
                setAnexos(data);
            });

    },[procedimiento]);

    return(
    <>
    {/* Muestra un procedimiento en particular recivido por parametro.
    ENCABEZADO - TITULO - OBJETIVO - ALCANCE */}
        <div
            className="row justify-content-center align-items-center g-2"
        >
            <div className="col">
                <img className="img-fluid rounded-top" src={logo} alt="Taller Avellaneda" width={200} />
            </div>
            <div className="col">
                <div>Código: {procedimiento.Codigo} </div>
                <div>Versión: {procedimiento.Version}</div>
                <div>Fecha Vigencia: {procedimiento.Fecha_vigencia} </div>
            </div>
            <div className="col">
                <div>Elaboró: {procedimiento.Resp_elaboracion} </div>
                <div>Revisó: {procedimiento.Resp_revision} </div>
                <div>Aprobó: {procedimiento.Resp_aprobacion} </div>
            </div>
        </div>
        <hr />
        <div className="titulo m-2">
            <h3>{procedimiento.Titulo}</h3>
            <div>Área: {procedimiento.Area}</div>
        </div>
        {
            procedimiento.Tipo_documento==="Procedimiento"?
            <>
                <div className="subtitulo">Objetivo:</div>
                <div className="parrafo">{procedimiento.Objetivo}</div>
                <div className="subtitulo">Alcance:</div>
                <div className="parrafo">{procedimiento.Alcance}</div>

                <div className="subtitulo">Responsabilidades:</div>
                {
                    responsabilidades.map((resp,key)=>(
                        <div className="parrafo" key={key}>{resp.Descripcion}</div>
                    ))
                }

                <div className="subtitulo">Definiciones:</div>
                {
                    definiciones.map((def,key)=>(
                        <div className="parrafo" key={key}>{def.Definicion}</div>
                    ))
                }
                <div className="subtitulo">Instruccioens y Descripción:</div>
                {
                    descripciones.map((descripcion,key)=>(
                        descripcion.Tipo==="Titulo"?
                        <div className="tipo-titulo" key={key}>{descripcion.Dato}</div>
                        :
                        descripcion.Tipo==="Subtitulo"?
                        <div className="tipo-subtitulo" key={key}>{descripcion.Dato}</div>
                        :
                        descripcion.Tipo==="Parrafo"?
                        <div className="tipo-parrafo" key={key}>{descripcion.Dato}</div>
                        :
                        descripcion.Tipo==="Item1"?
                        <div className="tipo-item1" key={key}>{descripcion.Dato}</div>
                        :
                        descripcion.Tipo==="Item2"?
                        <div className="tipo-item2" key={key}>{descripcion.Dato}</div>
                        :
                        descripcion.Tipo==="Item3"?
                        <div className="tipo-item3" key={key}>{descripcion.Dato}</div>
                        :
                        descripcion.Tipo==="Item4"?
                        <div className="tipo-item4" key={key}>{descripcion.Dato}</div>
                        :
                        descripcion.Tipo==="Imagen"?
                        <div className="d-flex justify-content-center">
                            <img
                            src={"/sgc/img/documentos/" + descripcion.Dato}
                            className="img-fluid rounded-top tipo-imagen"
                            alt="Imagen instructivo descripcion"
                            />
                        </div>
                        :
                        descripcion.Tipo==="Tabla"?
                        <div
                            className="table-responsive-md"
                        >
                            <table
                                className="table table-secondary"
                            >
                                <thead>
                                    <tr>
                                        {
                                            descripcion.Dato.split("|||")[0].split("|").map(h=>(
                                                <th>{h}</th>
                                            ))
                                        }
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        descripcion.Dato.split("|||")[1].split("||").map(row=>(
                                            <tr>
                                                {
                                                    row.split("|").map(d=>(
                                                        <td>{d}</td>
                                                    ))
                                                }
                                            </tr>
                                        ))
                                    }
                                </tbody>
                            </table>
                        </div>
                        
                        :
                        <div></div>
                    ))
                }
                <div className="subtitulo">Documentos de Referencia:</div>
                {
                    documentosReferencia.map(doc=>(
                        <div className="tipo-item1">{doc.Documento}</div>
                    ))
                }
                <div className="subtitulo">Registros:</div>
                <div
                    className="table-responsive"
                >
                    <table
                        className="table table-secondary"
                    >
                        <thead>
                            <tr>
                                <th>Título</th>
                                <th>Ordenamiento</th>
                                <th>Sector que Archiva</th>
                                <th>Tipo de Soporte</th>
                                <th>Periodo de Almacenamiento</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                registros?.map((reg,key)=>(
                                    <tr key={key}>
                                        <td>{reg.Titulo}</td>
                                        <td>{reg.Ordenamiento}</td>
                                        <td>{reg.Sector}</td>
                                        <td>{reg.Soporte}</td>
                                        <td>{reg.Periodo}</td>
                                    </tr>
                                ))
                            }
                        </tbody>
                    </table>
                </div>
                
                <div className="subtitulo">Control de Cambios:</div>
                {
                    controlCambios?.map((control,key)=>(
                        <div className="parrafo">{control.Control_cambio}</div>
                    ))
                }
                <div className="subtitulo">Anexos:</div>
                {
                    anexos?.map((anexo,key)=>(
                        anexo.Tipo==="Titulo"?
                        <div className="tipo-titulo" key={key}>{anexo.Dato}</div>
                        :
                        anexo.Tipo==="Subtitulo"?
                        <div className="tipo-subtitulo" key={key}>{anexo.Dato}</div>
                        :
                        anexo.Tipo==="Parrafo"?
                        <div className="tipo-parrafo" key={key}>{anexo.Dato}</div>
                        :
                        anexo.Tipo==="Item1"?
                        <div className="tipo-item1" key={key}>{anexo.Dato}</div>
                        :
                        anexo.Tipo==="Item2"?
                        <div className="tipo-item2" key={key}>{anexo.Dato}</div>
                        :
                        anexo.Tipo==="Item3"?
                        <div className="tipo-item3" key={key}>{anexo.Dato}</div>
                        :
                        anexo.Tipo==="Item4"?
                        <div className="tipo-item4" key={key}>{anexo.Dato}</div>
                        :
                        anexo.Tipo==="Imagen"?
                        <div className="d-flex justify-content-center">
                            <img
                            src={"/sgc/img/documentos/" + anexo.Dato}
                            className="img-fluid rounded-top tipo-imagen"
                            alt="Imagen instructivo descripcion"
                            />
                        </div>
                        :
                        anexo.Tipo==="Tabla"?
                        <div
                            className="table-responsive-md"
                        >
                            <table
                                className="table table-secondary"
                            >
                                <thead>
                                    <tr>
                                        {
                                            anexo.Dato.split("|||")[0].split("|").map(h=>(
                                                <th>{h}</th>
                                            ))
                                        }
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        anexo.Dato.split("|||")[1].split("||").map(row=>(
                                            <tr>
                                                {
                                                    row.split("|").map(d=>(
                                                        <td>{d}</td>
                                                    ))
                                                }
                                            </tr>
                                        ))
                                    }
                                </tbody>
                            </table>
                        </div>
                        
                        :
                        <div></div>
                    ))
                }
            </>
            :
            <div>
                {
                    descripciones.map((descripcion,key)=>(
                        descripcion.Tipo==="Titulo"?
                        <div className="tipo-titulo" key={key}>{descripcion.Dato}</div>
                        :
                        descripcion.Tipo==="Subtitulo"?
                        <div className="tipo-subtitulo" key={key}>{descripcion.Dato}</div>
                        :
                        descripcion.Tipo==="Parrafo"?
                        <div className="tipo-parrafo" key={key}>{descripcion.Dato}</div>
                        :
                        descripcion.Tipo==="Item1"?
                        <div className="tipo-item1" key={key}>{descripcion.Dato}</div>
                        :
                        descripcion.Tipo==="Item2"?
                        <div className="tipo-item2" key={key}>{descripcion.Dato}</div>
                        :
                        descripcion.Tipo==="Item3"?
                        <div className="tipo-item3" key={key}>{descripcion.Dato}</div>
                        :
                        descripcion.Tipo==="Item4"?
                        <div className="tipo-item4" key={key}>{descripcion.Dato}</div>
                        :
                        descripcion.Tipo==="Imagen"?
                        <div className="d-flex justify-content-center">
                            <img
                            src={"/sgc/img/documentos/" + descripcion.Dato}
                            className="img-fluid rounded-top tipo-imagen"
                            alt="Imagen instructivo descripcion"
                            />
                        </div>
                        :
                        descripcion.Tipo==="Tabla"?
                        <div
                            className="table-responsive-md"
                        >
                            <table
                                className="table table-secondary"
                            >
                                <thead>
                                    <tr>
                                        {
                                            descripcion.Dato.split("|||")[0].split("|").map(h=>(
                                                <th>{h}</th>
                                            ))
                                        }
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        descripcion.Dato.split("|||")[1].split("||").map(row=>(
                                            <tr>
                                                {
                                                    row.split("|").map(d=>(
                                                        <td>{d}</td>
                                                    ))
                                                }
                                            </tr>
                                        ))
                                    }
                                </tbody>
                            </table>
                        </div>
                        
                        :
                        <div></div>
                    ))
                }
                <div className="subtitulo">Control de Cambios:</div>
                {
                    controlCambios?.map((control,key)=>(
                        <div className="parrafo">{control.Control_cambio}</div>
                    ))
                }
            </div>
        }
    <hr />    
    <div className="d-flex justify-content-center text-muted">Sistema Integral Taller Avellaneda</div>
    </>
    )
}

